import React from 'react'
import { Field } from 'react-final-form'
import MenuItem from '@material-ui/core/MenuItem'
import StyledTextField from './StyledTextField'

const SelectField = ({
  id,
  options,
  name,
  label,
  variant,
  validate,
  ...props
}) => (
  <Field
    name={name}
    validate={validate}
    initialValue={options[0].value}
  >
    {({ input, meta }) => (
      <StyledTextField
        select
        id={id}
        variant={variant}
        label={label}
        {...props}
        {...input}
      >
        {options.map(option => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </StyledTextField>
    )}
  </Field>
)

export default SelectField
